import { Select } from '@navikt/ds-react'
import styled from 'styled-components'
import { Widget, WidgetProps } from 'index.d'
import { WidgetPropType } from 'index.pt'
import SmileyWidget from './SmileyWidget'
import _ from 'lodash'
import PT from 'prop-types'
import React, { useState } from 'react'

interface Mood {
  label: string;
  value: string
}

const SmileyOptionsDiv = styled.div`
  padding: 1rem;
`

const SmileyOptionsWidget: React.FC<WidgetProps> = ({ onUpdate, widget }: WidgetProps): JSX.Element => {
  const [mood, setMood] = useState<string>(widget!.options.mood)

  const chooseMood = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newWidget: Widget = _.cloneDeep(widget)
    newWidget.options.mood = e.target.value
    setMood(e.target.value)
    onUpdate(newWidget)
  }

  return (
    <SmileyOptionsDiv className='w-SmileyOptionsWidget'>
      <Select
        size='small'
        id='w-SmileyOptionsWidget__mood-select-id'
        label='mood'
        value={mood || ''}
        onChange={chooseMood}
      >
        {SmileyWidget.properties.options.availableMoods.map((_mood: Mood) => {
          return <option key={_mood.label} value={_mood.value}>{_mood.label}{' - '}{_mood.value}</option>
        })}
      </Select>
    </SmileyOptionsDiv>
  )
}

SmileyOptionsWidget.propTypes = {
  onUpdate: PT.func.isRequired,
  widget: WidgetPropType.isRequired
}

export default SmileyOptionsWidget
